import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { TDrawerOpenFaqEventParams } from '@/_analytic/events/drawer-open-faq/_types';

export const drawerOpenFaqEvent = (params: TDrawerOpenFaqEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.DRAWER_OPEN_FAQ,
    params,
  });
};
